import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex justify-content-center" }
const _hoisted_2 = { class: "flex flex-wrap align-items-center justify-content-between gap-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl text-900 font-bold" }, "Búsquedas", -1 /* HOISTED */)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex flex-column gap-2" }
const _hoisted_7 = { class: "p-float-label mt-3" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "p-error" }
const _hoisted_10 = { class: "p-float-label mt-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "include",
  class: "ml-6"
}, "Sólo para el perfil actual", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.showAdd)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 0,
          value: _ctx.dataSearch,
          paginator: true,
          rows: 5
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_Button, {
                icon: "pi pi-plus",
                rounded: "",
                raised: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAdd = true))
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "name",
              header: "Nombre",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  label: slotProps.data.name,
                  link: "",
                  onClick: ($event: any) => (_ctx.$emit('click:setSearch',slotProps.data))
                }, null, 8 /* PROPS */, ["label", "onClick"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_Column, {
              field: "data",
              header: "Criterios",
              style: {"width":"75%"}
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("p", {
                  innerHTML: _ctx.formatData(slotProps.data)
                }, null, 8 /* PROPS */, _hoisted_4)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_Column, null, {
              body: _withCtx(({ data }) => [
                _withDirectives(_createElementVNode("i", {
                  class: "pi pi-trash",
                  style: {"color":"#D32F2F"},
                  onClick: ($event: any) => (_ctx.deleteSearch(data))
                }, null, 8 /* PROPS */, _hoisted_5), [
                  [_directive_tooltip, 'Eliminar registro']
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["value"]))
      : (_openBlock(), _createBlock(_component_Card, { key: 1 }, {
          title: _withCtx(() => [
            _createTextVNode("Nueva búsqueda ")
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_InputText, {
                  id: "name",
                  modelValue: _ctx.data.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.name) = $event)),
                  type: "text",
                  class: _normalizeClass({ 'p-invalid': _ctx.v$.name.$error && _ctx.submitted }),
                  "aria-describedby": "text-error"
                }, null, 8 /* PROPS */, ["modelValue", "class"]),
                _createElementVNode("label", {
                  for: "name",
                  class: _normalizeClass({ 'p-invalid': _ctx.v$.name.$error && _ctx.submitted, 'customrequired': true })
                }, "Nombre", 2 /* CLASS */)
              ]),
              (_ctx.submitted)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.name.$errors, (error) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: error.$uid
                      }, [
                        _createElementVNode("small", _hoisted_9, _toDisplayString(error.$message), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_InputSwitch, {
                  id: "incluir",
                  modelValue: _ctx.includeCurrentProfile,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.includeCurrentProfile) = $event)),
                  binary: true
                }, null, 8 /* PROPS */, ["modelValue"]),
                _hoisted_11
              ]),
              _createVNode(_component_Button, {
                label: "Añadir",
                onClick: _ctx.saveData
              }, null, 8 /* PROPS */, ["onClick"]),
              _createVNode(_component_Button, {
                label: "Cancelar",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAdd=false)),
                severity: "danger"
              })
            ])
          ]),
          _: 1 /* STABLE */
        }))
  ]))
}